export class DefaultPatientStudyResultHistoryModel {
  SelectedAnalyzerTab: string;
  SelectedFilterBtn: string;
  SelectedExamList: SelectedExamList[];
}

export class SelectedExamList {
  ExamName: string;
}
